import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Grid2 as Grid,
  DialogContentText,
  Typography
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import { registerBusiness } from 'actions/contactActions';

const validationSchema = Yup.object({
  businessName: Yup.string().required('Business name is required'),
  mobile: Yup.string().required('Mobile number is required'),
  whatsapp: Yup.string(),
  // helpline: Yup.string(),
  email: Yup.string().email('Invalid email'),
  // gstnno: Yup.string(),
  address: Yup.string()
});

const initialValues = {
  businessName: "",
  mobile: "",
  email: "",
  address: ""
};

const RegisterBusinessDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const handleSubmit = async (values, { resetForm }) => {
    await dispatch(registerBusiness(values));

    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant='h3' color="textPrimary">Register Business</Typography>
      </DialogTitle>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleBlur, handleChange }) => (
          <Form>
            <DialogContent>
              <DialogContentText variant="subtitle" color={"textSecondary"} mt={-2} mb={4}>
                To register for the solution, please share your contact details
                and business name. Team will reach out soon.
              </DialogContentText>
              <Grid container spacing={2} mb={2}>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    name="businessName"
                    id="businessName"
                    label="Business Name"
                    type="text"
                    value={values.businessName}
                    variant="outlined"
                    fullWidth
                    onBlur={handleBlur}
                    onChange={handleChange}
                    inputProps={{ maxLength: 80 }}
                    error={Boolean(touched.businessName && errors.businessName)}
                    helperText={touched.businessName && errors.businessName}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    name="mobile"
                    id="mobile"
                    label="Mobile"
                    type="text"
                    value={values.mobile}
                    variant="outlined"
                    fullWidth
                    onBlur={handleBlur}
                    onChange={handleChange}
                    inputProps={{ maxLength: 15 }}
                    error={Boolean(touched.mobile && errors.mobile)}
                    helperText={touched.mobile && errors.mobile}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    name="email"
                    id="email"
                    label="Email"
                    type="text"
                    value={values.email}
                    variant="outlined"
                    fullWidth
                    onBlur={handleBlur}
                    onChange={handleChange}
                    inputProps={{ maxLength: 80 }}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <TextField
                    name="address"
                    id="address"
                    label="Address"
                    type="text"
                    value={values.address}
                    variant="outlined"
                    fullWidth
                    onBlur={handleBlur}
                    onChange={handleChange}
                    inputProps={{ maxLength: 120 }}
                    error={Boolean(touched.address && errors.address)}
                    helperText={touched.address && errors.address}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose} variant="outlined">Cancel</Button>
              <Button type="submit" variant="contained" color="primary">Submit</Button>
            </DialogActions>
          </Form>
        )}
      </Formik>

    </Dialog>
  );
};

export default RegisterBusinessDialog;
